import { privateApi } from 'services';
import { RecentlyViewedBrandsAudience } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchRecentlyViewedBrandsAudiences = async (
    userId: string,
    businessAccountId: string,
): Promise<RecentlyViewedBrandsAudience[]> =>
    privateApi.get<RecentlyViewedBrandsAudience[]>(
        `users/${userId}/recently-visited/business-accounts/${businessAccountId}/brands-audiences`,
    );

const postRecentlyViewedBrandsAudience = async (
    userId: string,
    brandsAudienceId: string,
): Promise<RecentlyViewedBrandsAudience> =>
    privateApi.post<RecentlyViewedBrandsAudience>(
        `users/${userId}/recently-visited/brands-audiences/${brandsAudienceId}`,
    );

export const RecentlyViewedBrandsAudienceGateway = {
    fetchRecentlyViewedBrandsAudiences,
    postRecentlyViewedBrandsAudience,
};

const cancelableFetchRecentlyViewedBrandsAudiences = async (
    userId: string,
    businessAccountId: string,
): Promise<RecentlyViewedBrandsAudience[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<RecentlyViewedBrandsAudience[]>(
        `users/${userId}/recently-visited/business-accounts/${businessAccountId}/brands-audiences`,
    );

export const CancelableRecentlyViewedBrandsAudienceGateway = {
    cancelableFetchRecentlyViewedBrandsAudiences,
};
